import React from "react";
import ContentModerationList from "@/components/contentModeration/ContentModerationList";
import { breadcrumb_key } from "@/constants/translation/common.translation";
import { contentModeration } from "@/libs/routes";

/**
 * Content Moderation > FeedPosts: list with search, status / date filters and View / Deactivate / Reactivate / Delete.
 */
const FeedPostsModerationList = () => (
  <ContentModerationList sectionKey="feedPosts" />
);

FeedPostsModerationList.breadCrumbArray = [
  {
    name: breadcrumb_key.contentModeration.feedPosts.list,
    pathname: contentModeration.feedPosts.list,
    active: true,
  },
];

export default FeedPostsModerationList;
